import styles from './DemoLoginPage.module.css'
import { useDispatch } from 'react-redux'
import { auth } from '../../features/authSlice'

export const DemoLoginPage = () => {
	const dispatch = useDispatch()

	return (
		<div className={styles.container}>
			<button
				onClick={() => {
					dispatch(
						auth({
							email: 'bob@bob.com',
							password: 'bob',
							mode: 'login',
						})
					)
				}}
			>
				Demo user 1: Bob
			</button>
			<button
				onClick={() => {
					dispatch(
						auth({
							email: 'alice@alice.com',
							password: 'alice',
							mode: 'login',
						})
					)
				}}
			>
				Demo user 2: Alice
			</button>
			<button
				onClick={() => {
					dispatch(
						auth({
							email: 'anna@anna.com',
							password: 'anna',
							mode: 'login',
						})
					)
				}}
			>
				Demo user 3: Anna
			</button>
		</div>
	)
}
